import React from 'react'
import './aboutUs.css'

const AboutUs = () => {
    return (
        <>
            <div className="privacyMain">
                <div className="privacyInner">
                    <div className="privacyText">About Us</div>
                    <div className="divider1"></div>
                    <h4 className="heading textCentrerAboutHeading">Helping You Find Your Perfect Ride</h4>
                    <div className='detailText' style={{ marginTop: "15px" }}>
                        Bus Arabia is a reliable online bus booking platform helping people effortlessly move across
                        Middle Eastern countries. From the bustling streets of UAE to the historic landmarks of
                        Egypt and stretching deserts of Saudi Arabia, and from the vibrant cities of Jordan to the culturally
                        rich Turkey, we connect you to a wide range of destinations across the region.
                    </div> <br />
                    <div className='detailText'>
                        At Bus Arabia, we realize that every traveler is unique, which is why we provide a diverse range
                        of options for online bus ticket booking within Saudi Arabia, UAE, Oman, and other Middle
                        Eastern countries for your specific needs. From luxury coaches to budget-friendly choices, you
                        will find it all here. And to make your travel truly stress-free, we also offer cargo services where
                        you can transport luggage of any volume without any hassle.
                    </div> <br />
                    <div className='detailText'>
                        Our platform’s unique strength lies in allowing you to compare ticket prices, schedules, and
                        amenities, making it easy to book the most suitable ticket for your budget and preferences.
                    </div> <br />
                    <div className='detailText'>
                        Whether you are traveling for business or leisure, solo or with a group, or you are searching for
                        reliable Hajj and Umrah bus packages, Bus Arabia is your trusted companion for a stress-free
                        ticket booking process. Start planning your next adventure today, and let us take you wherever
                        you want to go with ease.
                    </div>
                    <h4 className="heading textCentrerAboutHeading">Our Mission</h4>
                    <div className='detailText' style={{ marginTop: "15px" }}>
                        To simplify bus travel for everyone. We want to achieve this by offering a smooth booking
                        process that involves a range of bus ticket options. Besides, we help travelers make informed
                        decisions through clear and concise information about available routes, prices, and bus
                        operators. With only a few clicks, you can easily find the perfect ticket.
                    </div>
                    <h4 className="heading textCentrerAboutHeading">Our Values</h4>
                    <div className="overflow-x-auto" style={{ marginTop: "15px" }}>
                        <table className="w-full border border-gray-300 text-left aboutUsTable">
                            <thead>
                                <tr>
                                    <th className="border border-gray-300 p-4 font-semibold tableheadingaboutUs">Customer-centric Attitude</th>
                                    <th className="border border-gray-300 p-4 font-semibold tableheadingaboutUs">Quality</th>
                                    <th className="border border-gray-300 p-4 font-semibold tableheadingaboutUs">Accountability</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td className="border border-gray-300 p-4 text-gray-700 abouUsTableLowerSection">
                                        Our customers’ needs and satisfaction are at the heart of our work ethic.
                                        We listen to their queries and exceed their expectations every step of the way.
                                    </td>
                                    <td className="border border-gray-300 p-4 text-gray-700 abouUsTableLowerSection">
                                        We prioritize quality in everything we do. From the bus operators we partner
                                        with, to the customer service we provide, excellence is at the heart of all our operations.
                                    </td>
                                    <td className="border border-gray-300 p-4 text-gray-700 abouUsTableLowerSection">
                                        We’re fully accountable for our work and go all out to fulfil what we commit to.
                                        This makes us a reliable choice for anyone wanting to travel without facing unexpected disruptions.
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </>
    )
}

export default AboutUs
